<template src="./navbar.html"></template>

<script>
export default {
    data(){
        return{
            toggleMenu:false,
            scrollPosition: null,
            isProduct: false,
            openMenu:false
        }
    },
    // watch:{
    //     '$route':{
    //         immediate:true,
    //         handler: function(val) {
    //             if(
    //                 val.path == '/accounting-software'
    //                 || val.path == ''
    //                 ){
    //                 this.isProduct = true;
    //             }                
    //             else{
    //                 this.isProduct = false;
    //             }
    //         }
    //     }

    // },
    methods:{
        updateScroll() {
            this.scrollPosition = window.scrollY
        },

        toggleNavMenu(){
            this.openMenu = !this.openMenu
            console.log("Nav Burger clicked");
            

        //     let menu = document.getElementById('navbar-menu');
        //     if(menu.style.display == "none"){
        //         menu.style.display = "block";
        //     }
        //     else{
        //         menu.style.display = "none";
        //     }
        }
    },

    destroy() {
      window.removeEventListener('scroll', this.updateScroll)
    },

    created(){
        window.addEventListener('scroll', this.updateScroll);
    }
}
</script>




// WEBPACK FOOTER //
// src/components/layout/navbar/navbar.vue